import { StreamsState } from './streams.state'

export const getters = {
  isScreensharing (state: StreamsState) {
    return state.desktopStreamId !== null
  }
}
